import React from 'react'
import { ChevronRightIcon } from '@components/Icons'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { colors } from '@lib/colors'

interface WorkOrderTaskButtonsProps {
  tasks: WorkOrderTask[]
  goToTask: (taskId: string) => void
}

const WorkOrderTaskButtons = ({ tasks, goToTask }: WorkOrderTaskButtonsProps) => {
  return (
    <View style={ styles.buttonsWrapper }>
      { tasks?.map((task, index) => (
        // For index === 0, do not use borderTop
        <Pressable
          key={ index }
          style={ index ? styles.buttonWithBorder : styles.buttonWithoutBorder }
          onPress={ () => goToTask(task.id!) }
        >
          <Text style={ styles.taskName }>{task.name}</Text>
          <ChevronRightIcon size={25} color={ colors.gray[300] } />
        </Pressable>
      ))}
    </View>
  )
}

export default WorkOrderTaskButtons

const styles = StyleSheet.create({
  buttonsWrapper: {
    backgroundColor: colors.white,
    borderRadius: 3,
    marginTop: 20,
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
  },
  buttonWithBorder: {
    alignItems: 'center',
    borderTopColor: colors.gray[300],
    borderTopWidth: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    padding: 12,
    paddingLeft: 16,
  },
  buttonWithoutBorder: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    paddingLeft: 16,
  },
  taskName: {
    color: colors.blue[500],
    fontSize: 14,
    fontWeight: '600',
    flex: 1,
  },
})
